module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Billionaire's Bride of Innocence")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "application/xhtml+xml; charset=utf-8",
      "http-equiv": "content-type"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm02"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageii"
    }
  }, [_c('br'), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/02.jpg"
    }
  })])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("When a wealthy man takes a wife,")])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("it’s not always for love….")])])])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("Meet Russell, Hugh and James, three wealthy Sydney businessmen who’ve been the best of friends for ages. They know each other very well—including the reasons none of them believe in marrying for love.")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("While Russell and Hugh have so far remained single, James is about to embark on his second marriage.")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("But all this is set to change as Russell and Hugh are also driven to the altar. Have they changed their minds about love—or are they ruthlessly making marriages of convenience?")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("Find out in Miranda Lee’s sizzling, breathtaking, daring new trilogy, out this fall!")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("Book one:"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Billionaire’s Bride of Vengeance")])]), _c('br'), _vm._v("\n(September)")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("Book two:"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Billionaire’s Bride of Convenience")])]), _c('br'), _vm._v("\n(October)")])]), _c('p', {
    staticClass: "paraCenter1"
  }, [_c('span', [_vm._v("Book three:"), _c('br'), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Billionaire’s Bride of Innocence")])]), _c('br'), _vm._v("\n(November)")])])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pageii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-453e67cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/billionairesbrideofinnocencethe_fm02.vue
// module id = 60
// module chunks = 0